import { Routes } from '@angular/router';
import { ExposeAppointmentsFacade } from '@ui/tenant-pool/shared/expose/appointments/data-access';

export const ROUTES: Routes = [
  {
    path: 'apply/:id',
    loadChildren: () =>
      import('@ui/tenant-pool/shared/expose/apply/feature').then(
        m => m.applyRoutes
      )
  },
  // current emails: RS_RESET_PASSWORD
  {
    path: 'deeplink-redirect/:appClientName/:registerPath/:token',
    loadComponent: () =>
      import('./components/deeplink-redirect/deeplink-redirect.component').then(
        m => m.DeeplinkRedirectComponent
      )
  },
  {
    path: 'deeplink-redirect/:appClientName/:appRedirectPath/:appRedirectAction/:customerIdent/:token',
    loadComponent: () =>
      import('./components/deeplink-redirect/deeplink-redirect.component').then(
        m => m.DeeplinkRedirectComponent
      )
  },
  {
    path: 'deeplink-redirect/:appClientName/:appRedirectPath/:appRedirectAction/:erpIdentifiers',
    loadComponent: () =>
      import('./components/deeplink-redirect/deeplink-redirect.component').then(
        m => m.DeeplinkRedirectComponent
      )
  },
  {
    path: 'deeplink-redirect/:appClientName/:appRedirectPath/:appRedirectAction/:customerIdent/:token/:residentVerificationCode',
    loadComponent: () =>
      import('./components/deeplink-redirect/deeplink-redirect.component').then(
        m => m.DeeplinkRedirectComponent
      )
  },
  // Email "verify now" button → start the SMS verification flow (ART-19473)
  {
    path: 'verification/sms',
    loadComponent: () =>
      import('./components/sms-verification/sms-verification-landing.component').then(
        m => m.SmsVerificationLandingComponent
      )
  },
  {
    path: 'signContract',
    loadComponent: () =>
      import('./components/digital-contract/digital-contract-landing.component').then(
        m => m.DigitalContractLandingComponent
      )
  },
  {
    path: 'verifyCode',
    loadComponent: () =>
      import('./components/digital-contract/verify-code-landing.component').then(
        m => m.VerifyCodeLandingComponent
      )
  },
  {
    path: 'guest',
    loadComponent: () =>
      import('./components/guest-mode/guest-mode-landing.component').then(
        m => m.GuestModeLandingComponent
      ),
    children: [
      {
        path: 'viewing',
        // Only for `declineAllAppointments`, whose mutation carries no token
        // and so is the one method on this facade a guest can call. Everything
        // else the page does is the guest-mode slice's.
        providers: [ExposeAppointmentsFacade],
        loadComponent: () =>
          import('./components/guest-mode/components/guest-viewing/guest-viewing.component').then(
            m => m.GuestViewingComponent
          )
      },
      {
        path: 'intent',
        loadComponent: () =>
          import('./components/guest-mode/components/guest-intent/guest-intent.component').then(
            m => m.GuestIntentComponent
          )
      }
    ]
  },
  /**
   * Safe route redirects.
   * Those are fallbacks after changing our routes structure and
   * app's architecture.
   * Most of the outside links points to the routes specified above,
   * but we need to make sure nothing is broken.
   */
  {
    path: 'properties/apply/:id',
    redirectTo: 'apply/:id'
  }
];
